import React, { Component } from 'react'
import apiService from '../../services/apiservices'
import Select from 'react-select'

class Kitchens extends Component {
    constructor() {
        super()
        this.state = {
            KitchensList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getKitchensListData()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getKitchensListData = () => {
        apiService.getKitchensListData()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                    if (listData.status === "SUCCESS") {
                        this.setState({
                            KitchensList: listData.data ? listData.data : {},
                        })
                    } else {
                        console.error("Filed response from costCenter list api")
                    }
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }

    render() {
        let list = {}
        list = Object.keys(this.state.KitchensList).map((value,index) => {
            return {
                label : this.state.KitchensList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));
       

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={list}
                placeholder="Select Kitchen"
                onChange={(e) => { (e) ? this.props.kitchenChange(e) : this.props.kitchenChange([])}}
                />
            </div>
        )
    }
}

export default Kitchens


// WEBPACK FOOTER //
// ./src/modules/Employees Movement/Components/DropDowns/Kitchens.js